import { Box, Text } from '@rsos/base-components';
import * as capabilities from '@rsos/capstone/src/constants/capabilities';
import { DebugPanel } from '@rsos/debug-panel';
import CapabilityOverrideItem from './CapabilityOverrideItem';

const CapabilityDebugPanel = ({ onClose }: { onClose?: () => void }) => {
  const sortedCapabilities = Object.entries(capabilities).sort(
    ([keyA], [keyB]) => keyA.localeCompare(keyB),
  );

  return (
    <DebugPanel title="Frontend Capability Override" onClose={onClose}>
      <Text color="secondaryText" size="small">
        These values are local only; they only affect the frontend UI and will
        not even temporarily enable a capability in the backend.
      </Text>
      <Box
        height="400px"
        overflow="auto"
        border="1px solid"
        borderColor="heavyLineOutline"
      >
        {sortedCapabilities.map(([displayName, name]) => (
          <CapabilityOverrideItem
            displayName={displayName}
            name={name}
            key={name}
          />
        ))}
      </Box>
    </DebugPanel>
  );
};

export default CapabilityDebugPanel;
